export default '/build/139d155b.svg'